import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const getClientServiceSubscriptionTaskChecklistItemByTaskId = (taskId) => {
  return new Promise(async (resolve) => {
    try {
      const token = Cookies.get("Bearer");
      const response = await axios.get(
        `${FIRMFLOWURL}api/ClientServiceSubscriptionTaskChecklistItem/clientServiceSubscriptionTask/${taskId}`,
        {
          headers: { Authorization: token },
        }
      );
      console.log("Checklist items: ", response);
      resolve({ ...response, success: true });
    } catch (err) {
      console.log("error on getClientServiceSubscriptionTaskChecklistItem", err);
      if (err.message.includes(401)) {
        Cookies.remove("Bearer");
        window.location.replace("/");
        return;
      }
      resolve({ success: false, message: err.message });
    }
  });
};
